module.exports = __webpack_public_path__ + "media/images/sp/specials/okinawa_churaumi_aquarium/plan_main_2locations-a703c8adec9e4b8e6f12316882d17d11.jpg";